import { useTranslation } from "react-i18next";
import { Gallery } from "iconsax-react";
import { ToggleButton } from "@/shared/ui";
import { useAccessibilityControls } from "../hooks";

export default function ShowImagesRow() {
  const { t } = useTranslation("Sidebar");
  const { showImages, toggleShowImages } = useAccessibilityControls();

  return (
    <div className="flex items-center gap-2 my-1 radius-sm py-1">
      <div className="flex items-center justify-center">
        <Gallery size={18} color="currentColor" className="shrink-0 content-base-primary" />
      </div>
      <div className="flex items-center justify-between flex-1">
        <span className="text-label-sm content-base-primary whitespace-nowrap">{t("showImages")}</span>
        <ToggleButton checked={showImages} onChange={toggleShowImages} />
      </div>
    </div>
  );
}

